export default "__VITE_ASSET__DYWWrFDr__"